<template>
    <div class="gh-page gh-training-success-page">
        <gh-header/>
        <div class="gh-training-greating">
            <div class="container">
                <div class="gh-training-greating__inner">
                    <i class="el-icon-circle-check gh-icon-check"></i>
                    <h2 class="gh-heading">Welcome to the course, {{ firstName }}</h2>
                    <p class="gh-subheading">Congratulations on your decision to undertake training in {{ courseTitle }}. We’re thrilled to be joining you on this journey.</p>
                    <div class="gh-buttons">
                        <router-link class="gh-button gh-button--cta" to="/dashboard">
                            Go to Learning Portal
                        </router-link>
                        <a v-if="courseGuide" :href="courseGuide" target="_blank" class="gh-button gh-button--silver">
                            Download Course Guide
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="gh-body">
            <div class="container">
                <p>Your course combines a range of learning modes and resources, including journal articles, video lectures, handouts, online assessments, a private discussion forum, and more. These resources, along with instructions and tips to progress through the course, are accessible – 24/7 – from your <b>MHA Learning Portal</b>.</p>
                <p>We’ve emailed you further instructions on how to get started (please check both your inbox and junk/ promotions folders – if you can’t find your email there, <a href="/contact" target="_blank">contact us</a>).</p>
                <p>If you’d like to get dive into the materials straight away, use the navigation button above to go to your Learning Portal. Tip: We strongly recommend that you read your course guide before commencing your studies.</p>
                <p>If you have any questions or require assistance, don’t hesitate to <a href="/contact" target="_blank">contact us</a>.</p>
                <p>We look forward to supporting your educational journey!</p>
                <p>Kind regards,</p>
                <img src="/images/summit/Signature.png" alt="Pedro Gondim e-signature">
                <p>
                    Pedro Gondim<br>
                    CEO, Mental Health Academy.<br>
                </p>
            </div>
        </div>
        <gh-footer/>
    </div>
</template>

<script>
    export default {
        components: {
            ghHeader: () => import(/* webpackChunkName: "training" */ '@/views/public/header/index.vue'),
            ghFooter: () => import(/* webpackChunkName: "training" */ '@/views/public/footer/index.vue')
        },

        computed: {
            firstName () {
                return this.$route.query.firstName
            },

            courseTitle () {
                return this.$route.query.showTitle
                    ? this.$route.query.courseTitle
                    : 'this exciting field'
            },

            courseGuide () {
                return this.$route.query.courseGuide
            }
        }
    }
</script>
<style lang="scss" scoped>
    .gh-buttons {
        display: flex;
        justify-content: center;
        margin-top: 2rem;

        .gh-button + .gh-button {
            margin-left: 1rem;
        }
    }

    .container {
        padding: 30px 20px;
        max-width: 900px;
    }

    img {
        margin-top: 2rem;
        max-width: 250px;
    }

    .gh-training-greating {
        background: white;
        padding-top: 3rem;
        .gh-training-greating__inner {
            text-align: center;

            .gh-heading {
                color: #514A9D;
                margin: 3rem 0;
            }

            .gh-subheading {
                color: #2C3138;
                font-size: 1.4rem;
                max-width: 850px;
                margin: auto;
            }
        }
    }
    .gh-icon-check {
        font-size: 6rem;
        color: #514A9D;
    }

    .gh-body {
        background: #F0F6F8;

        p {
            font-size: 1.3rem;
            color: #2C3138;
            font-weight: 400;

            + p {
                margin-top: 1.5rem;
            }
        }
    }

    @media screen and (min-width: 768px) {
        .gh-training-greating {
            padding-top: 5rem;
        }

        .container {
            padding: 50px 0;
        }
    }
</style>
